import { doDeleteRequest, doGetRequest, doPostRequest, doPutRequest } from "./mainAPI";
import { PRODUCT } from "../constants/mainAPI";
import {
    ProductDataCreate,
    ProductDataEdit,
    ProductsSuccessResponse,
    ProductSuccessResponse,
} from "../types/api/products";
import { ErrorResponseType } from "../types/api/main";
import { toFormData } from "../utils/toFormData";
import { getFileFromUrl } from "../utils/getFileFromUrl";

export const getProductsList = (
    centerId: string | undefined,
    callback?: (resp: ProductsSuccessResponse) => any,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
    searchParams?: Record<string, any>,
) => {
    return doGetRequest(`${PRODUCT}?center_id=${centerId}`, true, searchParams, callback, errorCallback);
};

export const getProductById = (
    productId: string | undefined,
    callback?: (resp: ProductSuccessResponse) => any,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    return doGetRequest(`${PRODUCT}/${productId}`, true, undefined, callback, errorCallback);
};

export const createNewProduct = async (
    data: ProductDataCreate,
    callback?: (resp: ProductSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    const formData = toFormData(data);
    data?.equipment?.forEach(function (element: any) {
        formData.append("equipment[]", element);
    });
    if (data?.photos?.length > 1) {
        let promises = [] as any;
        await data.photos.forEach((v: any, index: Number) => {
            v &&
                promises.push(
                    getFileFromUrl(v.photo.file, v.photo.name).then(r => {
                        r && formData.append(`photos[${index}]`, r);
                    }),
                );
        });

        await Promise.all(promises).finally(() => {
            return doPostRequest(PRODUCT, true, formData, {}, callback, errorCallback);
        });
    } else {
        return doPostRequest(PRODUCT, true, formData, {}, callback, errorCallback);
    }
};

export const editProduct = async (
    productId: string | undefined,
    data: ProductDataEdit,
    callback?: (resp: ProductSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    const formData = toFormData(data);
    if (data.delete_photos?.length > 0) {
        data.delete_photos.forEach((v: any, index: Number) => {
            formData.append(`delete_photos[${index}]`, v);
        });
    }
    let setNewEquipment = new Set(data?.equipment);
    let equipmentToDelete = data?.delete_equipment?.filter((num: any) => !setNewEquipment.has(num));

    data?.equipment?.forEach(function (element: any) {
        formData.append("equipment[]", element);
    });
    equipmentToDelete?.forEach(function (element: any) {
        formData.append("delete_equipment[]", element);
    });
    if (data?.photos?.length > 1) {
        let promises = [] as any;
        await data.photos.forEach((v: any, index: Number) => {
            v?.photo?.file &&
                promises.push(
                    getFileFromUrl(v.photo.file, v.photo.name).then(r => {
                        r && formData.append(`photos[${index}]`, r);
                    }),
                );
        });
        await Promise.all(promises).finally(() => {
            return doPutRequest(`${PRODUCT}/${productId}`, true, formData, {}, callback, errorCallback);
        });
    } else {
        return doPutRequest(`${PRODUCT}/${productId}`, true, formData, {}, callback, errorCallback);
    }
};

export const deleteProduct = (
    productId: string | undefined,
    callback?: (resp: any) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    return doDeleteRequest(`${PRODUCT}/${productId}`, true, {}, callback, errorCallback);
};
